var map = {
	"./1855": 211,
	"./1855.png": 211,
	"./222": 212,
	"./222.png": 212,
	"./about/bg-cta": 213,
	"./about/bg-cta.png": 213,
	"./about/bg-story": 214,
	"./about/bg-story.png": 214,
	"./about/bg-vision": 215,
	"./about/bg-vision.png": 215,
	"./about/person/jon": 44,
	"./about/person/jon.png": 44,
	"./about/person/jon.webp": 878,
	"./about/person/putra": 45,
	"./about/person/putra.png": 45,
	"./about/person/putra.webp": 879,
	"./about/person/ric": 46,
	"./about/person/ric.png": 46,
	"./about/person/ric.webp": 880,
	"./about/person/suren": 47,
	"./about/person/suren.png": 47,
	"./about/person/suren.webp": 881,
	"./about/person/yunita": 48,
	"./about/person/yunita.png": 48,
	"./about/person/yunita.webp": 882,
	"./about/social/blogger": 216,
	"./about/social/blogger.png": 216,
	"./about/social/email": 217,
	"./about/social/email.png": 217,
	"./about/social/facebook": 218,
	"./about/social/facebook.png": 218,
	"./about/social/instagram": 219,
	"./about/social/instagram.png": 219,
	"./about/social/linkedin": 220,
	"./about/social/linkedin.png": 220,
	"./about/social/pinterest": 221,
	"./about/social/pinterest.png": 221,
	"./about/social/youtube": 222,
	"./about/social/youtube.png": 222,
	"./about/world-map": 223,
	"./about/world-map.png": 223,
	"./amara": 224,
	"./amara.png": 224,
	"./apple-icon": 225,
	"./apple-icon.png": 225,
	"./arrow-down-icon": 226,
	"./arrow-down-icon.png": 226,
	"./attch": 227,
	"./attch.png": 227,
	"./avatar": 228,
	"./avatar.jpg": 228,
	"./banner/onboarding": 229,
	"./banner/onboarding.png": 229,
	"./banner/supervenue": 230,
	"./banner/supervenue.png": 230,
	"./bg-card": 231,
	"./bg-card.png": 231,
	"./bg-contact": 232,
	"./bg-contact.png": 232,
	"./bg-criteria": 233,
	"./bg-criteria.png": 233,
	"./bg-half": 234,
	"./bg-half.png": 234,
	"./calendar/arrow-right": 235,
	"./calendar/arrow-right.png": 235,
	"./calendar/calendar-check": 236,
	"./calendar/calendar-check.png": 236,
	"./calendar/change": 237,
	"./calendar/change.png": 237,
	"./calendar/google": 238,
	"./calendar/google.png": 238,
	"./calendar/outlook": 239,
	"./calendar/outlook.png": 239,
	"./down-icon": 240,
	"./down-icon-blue": 241,
	"./down-icon-blue.svg": 241,
	"./down-icon.svg": 240,
	"./facebook-icon": 242,
	"./facebook-icon.png": 242,
	"./favicon": 243,
	"./favicon.png": 243,
	"./filter-icon": 244,
	"./filter-icon.png": 244,
	"./frontend_application/Balon": 245,
	"./frontend_application/Balon.svg": 245,
	"./frontend_application/Bannerdesktop": 246,
	"./frontend_application/Bannerdesktop.png": 246,
	"./frontend_application/Bannermobile": 247,
	"./frontend_application/Bannermobile.png": 247,
	"./frontend_application/Bannertablet": 248,
	"./frontend_application/Bannertablet.png": 248,
	"./frontend_application/bank-placeholder": 249,
	"./frontend_application/bank-placeholder.svg": 249,
	"./frontend_application/banner-enquiry-ebook": 250,
	"./frontend_application/banner-enquiry-ebook.png": 250,
	"./frontend_application/banner-home": 49,
	"./frontend_application/banner-home.jpg": 49,
	"./frontend_application/banner-home.webp": 883,
	"./frontend_application/banner-miceneurol": 251,
	"./frontend_application/banner-miceneurol-2": 252,
	"./frontend_application/banner-miceneurol-2.png": 252,
	"./frontend_application/banner-miceneurol.png": 251,
	"./frontend_application/banner-onboard": 253,
	"./frontend_application/banner-onboard.png": 253,
	"./frontend_application/banner-post-enquiry": 254,
	"./frontend_application/banner-post-enquiry.png": 254,
	"./frontend_application/banner-sgbrideonthehunt-ipad": 255,
	"./frontend_application/banner-sgbrideonthehunt-ipad.png": 255,
	"./frontend_application/banner-sgbrideonthehunt-md": 256,
	"./frontend_application/banner-sgbrideonthehunt-md.png": 256,
	"./frontend_application/banner-sgbrideonthehunt-sm": 257,
	"./frontend_application/banner-sgbrideonthehunt-sm.png": 257,
	"./frontend_application/banner-sgbrideonthehunt-tablet": 258,
	"./frontend_application/banner-sgbrideonthehunt-tablet.png": 258,
	"./frontend_application/banner-sgbrideonthehunt2-md": 259,
	"./frontend_application/banner-sgbrideonthehunt2-md.png": 259,
	"./frontend_application/banner-sgbrideonthehunt2-sm": 260,
	"./frontend_application/banner-sgbrideonthehunt2-sm.png": 260,
	"./frontend_application/banner-upgrade": 261,
	"./frontend_application/banner-upgrade.png": 261,
	"./frontend_application/banner/eo-outside-sg/desktop": 262,
	"./frontend_application/banner/eo-outside-sg/desktop.png": 262,
	"./frontend_application/banner/eo-outside-sg/mobile": 263,
	"./frontend_application/banner/eo-outside-sg/mobile.png": 263,
	"./frontend_application/banner/eo-outside-sg/tab": 264,
	"./frontend_application/banner/eo-outside-sg/tab.png": 264,
	"./frontend_application/banner/eo-sg/desktop": 265,
	"./frontend_application/banner/eo-sg/desktop.png": 265,
	"./frontend_application/banner/eo-sg/mobile": 266,
	"./frontend_application/banner/eo-sg/mobile.png": 266,
	"./frontend_application/banner/eo-sg/tab": 267,
	"./frontend_application/banner/eo-sg/tab.png": 267,
	"./frontend_application/banner/free-outside-sg/desktop": 268,
	"./frontend_application/banner/free-outside-sg/desktop.png": 268,
	"./frontend_application/banner/free-outside-sg/mobile": 269,
	"./frontend_application/banner/free-outside-sg/mobile.png": 269,
	"./frontend_application/banner/free-outside-sg/tab": 270,
	"./frontend_application/banner/free-outside-sg/tab.png": 270,
	"./frontend_application/banner/free-sg/desktop": 271,
	"./frontend_application/banner/free-sg/desktop.png": 271,
	"./frontend_application/banner/free-sg/mobile": 272,
	"./frontend_application/banner/free-sg/mobile.png": 272,
	"./frontend_application/banner/free-sg/tab": 273,
	"./frontend_application/banner/free-sg/tab.png": 273,
	"./frontend_application/banner_emerge_venuerific_2022": 274,
	"./frontend_application/banner_emerge_venuerific_2022.png": 274,
	"./frontend_application/banner_get_more": 275,
	"./frontend_application/banner_get_more.jpg": 275,
	"./frontend_application/bell": 276,
	"./frontend_application/bell.png": 276,
	"./frontend_application/bg-upgrade": 277,
	"./frontend_application/bg-upgrade-text": 278,
	"./frontend_application/bg-upgrade-text-ipad": 279,
	"./frontend_application/bg-upgrade-text-ipad.png": 279,
	"./frontend_application/bg-upgrade-text-mobile": 280,
	"./frontend_application/bg-upgrade-text-mobile.png": 280,
	"./frontend_application/bg-upgrade-text.png": 278,
	"./frontend_application/bg-upgrade.png": 277,
	"./frontend_application/booking-banner": 281,
	"./frontend_application/booking-banner.jpg": 281,
	"./frontend_application/bottomnav/favourite": 282,
	"./frontend_application/bottomnav/favourite.svg": 282,
	"./frontend_application/bottomnav/marker": 283,
	"./frontend_application/bottomnav/marker.svg": 283,
	"./frontend_application/bottomnav/notification": 284,
	"./frontend_application/bottomnav/notification.svg": 284,
	"./frontend_application/bottomnav/profile": 285,
	"./frontend_application/bottomnav/profile.svg": 285,
	"./frontend_application/bottomnav/search": 286,
	"./frontend_application/bottomnav/search.svg": 286,
	"./frontend_application/bulb": 287,
	"./frontend_application/bulb.png": 287,
	"./frontend_application/celebrate-icon": 288,
	"./frontend_application/celebrate-icon.png": 288,
	"./frontend_application/christmas/bg-bottom": 289,
	"./frontend_application/christmas/bg-bottom.jpg": 289,
	"./frontend_application/christmas/bg-top": 290,
	"./frontend_application/christmas/bg-top.png": 290,
	"./frontend_application/christmas/bottom-decoration": 291,
	"./frontend_application/christmas/bottom-decoration.png": 291,
	"./frontend_application/christmas/boxes": 292,
	"./frontend_application/christmas/boxes.png": 292,
	"./frontend_application/christmas/campaign-one": 293,
	"./frontend_application/christmas/campaign-one.png": 293,
	"./frontend_application/christmas/campaign-three": 294,
	"./frontend_application/christmas/campaign-three.png": 294,
	"./frontend_application/christmas/campaign-two": 295,
	"./frontend_application/christmas/campaign-two.png": 295,
	"./frontend_application/christmas/candy-icon": 296,
	"./frontend_application/christmas/candy-icon.png": 296,
	"./frontend_application/christmas/candy-one": 297,
	"./frontend_application/christmas/candy-one.png": 297,
	"./frontend_application/christmas/candy-two": 298,
	"./frontend_application/christmas/candy-two.png": 298,
	"./frontend_application/christmas/christmas_desktop": 299,
	"./frontend_application/christmas/christmas_desktop.png": 299,
	"./frontend_application/christmas/christmas_mobile": 300,
	"./frontend_application/christmas/christmas_mobile.png": 300,
	"./frontend_application/christmas/fortune-wheel": 301,
	"./frontend_application/christmas/fortune-wheel.png": 301,
	"./frontend_application/christmas/partner-five": 302,
	"./frontend_application/christmas/partner-five.png": 302,
	"./frontend_application/christmas/partner-four": 303,
	"./frontend_application/christmas/partner-four.png": 303,
	"./frontend_application/christmas/partner-one": 304,
	"./frontend_application/christmas/partner-one.png": 304,
	"./frontend_application/christmas/partner-three": 305,
	"./frontend_application/christmas/partner-three.png": 305,
	"./frontend_application/christmas/partner-two": 306,
	"./frontend_application/christmas/partner-two.png": 306,
	"./frontend_application/christmas/play-background": 307,
	"./frontend_application/christmas/play-background.png": 307,
	"./frontend_application/christmas/play-logo": 308,
	"./frontend_application/christmas/play-logo.png": 308,
	"./frontend_application/christmas/star-icon": 309,
	"./frontend_application/christmas/star-icon.png": 309,
	"./frontend_application/christmas/top-decoration": 310,
	"./frontend_application/christmas/top-decoration.png": 310,
	"./frontend_application/christmas/wheel-icon": 311,
	"./frontend_application/christmas/wheel-icon.png": 311,
	"./frontend_application/content_production/Ray-Ban": 312,
	"./frontend_application/content_production/Ray-Ban.png": 312,
	"./frontend_application/content_production/bg_bottom": 313,
	"./frontend_application/content_production/bg_bottom.png": 313,
	"./frontend_application/content_production/bg_testi": 314,
	"./frontend_application/content_production/bg_testi.png": 314,
	"./frontend_application/content_production/bg_top": 315,
	"./frontend_application/content_production/bg_top.png": 315,
	"./frontend_application/content_production/client_1": 316,
	"./frontend_application/content_production/client_1.png": 316,
	"./frontend_application/content_production/client_10": 317,
	"./frontend_application/content_production/client_10.png": 317,
	"./frontend_application/content_production/client_11": 318,
	"./frontend_application/content_production/client_11.png": 318,
	"./frontend_application/content_production/client_12": 319,
	"./frontend_application/content_production/client_12.png": 319,
	"./frontend_application/content_production/client_13": 320,
	"./frontend_application/content_production/client_13.png": 320,
	"./frontend_application/content_production/client_14": 321,
	"./frontend_application/content_production/client_14.png": 321,
	"./frontend_application/content_production/client_2": 322,
	"./frontend_application/content_production/client_2.png": 322,
	"./frontend_application/content_production/client_3": 323,
	"./frontend_application/content_production/client_3.png": 323,
	"./frontend_application/content_production/client_4": 324,
	"./frontend_application/content_production/client_4.png": 324,
	"./frontend_application/content_production/client_5": 325,
	"./frontend_application/content_production/client_5.png": 325,
	"./frontend_application/content_production/client_6": 326,
	"./frontend_application/content_production/client_6.png": 326,
	"./frontend_application/content_production/client_7": 327,
	"./frontend_application/content_production/client_7.png": 327,
	"./frontend_application/content_production/client_8": 328,
	"./frontend_application/content_production/client_8.png": 328,
	"./frontend_application/content_production/client_9": 329,
	"./frontend_application/content_production/client_9.png": 329,
	"./frontend_application/content_production/client_six": 330,
	"./frontend_application/content_production/client_six.png": 330,
	"./frontend_application/content_production/image": 331,
	"./frontend_application/content_production/image.png": 331,
	"./frontend_application/content_production/other_service_one": 332,
	"./frontend_application/content_production/other_service_one.png": 332,
	"./frontend_application/content_production/other_service_three": 333,
	"./frontend_application/content_production/other_service_three.png": 333,
	"./frontend_application/content_production/other_service_two": 334,
	"./frontend_application/content_production/other_service_two.png": 334,
	"./frontend_application/content_production/service_img": 335,
	"./frontend_application/content_production/service_img.png": 335,
	"./frontend_application/content_production/top_service_one": 336,
	"./frontend_application/content_production/top_service_one.png": 336,
	"./frontend_application/content_production/top_service_three": 337,
	"./frontend_application/content_production/top_service_three.png": 337,
	"./frontend_application/content_production/top_service_two": 338,
	"./frontend_application/content_production/top_service_two.png": 338,
	"./frontend_application/content_production/user_one": 339,
	"./frontend_application/content_production/user_one.png": 339,
	"./frontend_application/content_production/user_three": 340,
	"./frontend_application/content_production/user_three.jpeg": 340,
	"./frontend_application/content_production/user_two": 341,
	"./frontend_application/content_production/user_two.png": 341,
	"./frontend_application/controls": 342,
	"./frontend_application/controls.png": 342,
	"./frontend_application/country/hk": 343,
	"./frontend_application/country/hk.jpg": 343,
	"./frontend_application/country/id": 344,
	"./frontend_application/country/id.jpg": 344,
	"./frontend_application/country/my": 345,
	"./frontend_application/country/my.jpg": 345,
	"./frontend_application/country/ph": 346,
	"./frontend_application/country/ph.jpg": 346,
	"./frontend_application/country/sg": 347,
	"./frontend_application/country/sg.jpg": 347,
	"./frontend_application/coupon-blue": 348,
	"./frontend_application/coupon-blue.png": 348,
	"./frontend_application/coupon-green": 349,
	"./frontend_application/coupon-green.png": 349,
	"./frontend_application/coupon-orange": 350,
	"./frontend_application/coupon-orange.png": 350,
	"./frontend_application/coupon-purple": 351,
	"./frontend_application/coupon-purple.png": 351,
	"./frontend_application/coupon-red": 352,
	"./frontend_application/coupon-red.png": 352,
	"./frontend_application/data-deals-icon": 353,
	"./frontend_application/data-deals-icon.png": 353,
	"./frontend_application/delete-icon": 354,
	"./frontend_application/delete-icon.png": 354,
	"./frontend_application/document-blank": 355,
	"./frontend_application/document-blank.png": 355,
	"./frontend_application/down-icon": 356,
	"./frontend_application/down-icon.svg": 356,
	"./frontend_application/edit-icon": 357,
	"./frontend_application/edit-icon.png": 357,
	"./frontend_application/eventtype/baby": 358,
	"./frontend_application/eventtype/baby.jpg": 358,
	"./frontend_application/eventtype/birthday": 359,
	"./frontend_application/eventtype/birthday.jpg": 359,
	"./frontend_application/eventtype/dinner": 360,
	"./frontend_application/eventtype/dinner.jpg": 360,
	"./frontend_application/eventtype/dnd": 361,
	"./frontend_application/eventtype/dnd.jpg": 361,
	"./frontend_application/eventtype/meeting": 362,
	"./frontend_application/eventtype/meeting.jpg": 362,
	"./frontend_application/eventtype/seminar": 363,
	"./frontend_application/eventtype/seminar.jpg": 363,
	"./frontend_application/eventtype/wedding": 364,
	"./frontend_application/eventtype/wedding.jpg": 364,
	"./frontend_application/fast-enquiry-bg": 365,
	"./frontend_application/fast-enquiry-bg.jpg": 365,
	"./frontend_application/fast-enquiry-btn-icon": 366,
	"./frontend_application/fast-enquiry-btn-icon.png": 366,
	"./frontend_application/fast-enquiry-icon": 367,
	"./frontend_application/fast-enquiry-icon.png": 367,
	"./frontend_application/favicon-196x196": 368,
	"./frontend_application/favicon-196x196.png": 368,
	"./frontend_application/filter-icon": 369,
	"./frontend_application/filter-icon.png": 369,
	"./frontend_application/footericon/blog": 370,
	"./frontend_application/footericon/blog.svg": 370,
	"./frontend_application/footericon/facebook": 371,
	"./frontend_application/footericon/facebook.svg": 371,
	"./frontend_application/footericon/instagram": 372,
	"./frontend_application/footericon/instagram.svg": 372,
	"./frontend_application/footericon/linkedin": 373,
	"./frontend_application/footericon/linkedin.svg": 373,
	"./frontend_application/footericon/mailto": 374,
	"./frontend_application/footericon/mailto.svg": 374,
	"./frontend_application/footericon/pinterest": 375,
	"./frontend_application/footericon/pinterest.svg": 375,
	"./frontend_application/footericon/telegram": 376,
	"./frontend_application/footericon/telegram.svg": 376,
	"./frontend_application/footericon/tiktok": 377,
	"./frontend_application/footericon/tiktok.svg": 377,
	"./frontend_application/footericon/youtube": 378,
	"./frontend_application/footericon/youtube.svg": 378,
	"./frontend_application/free_trial/banner_img": 379,
	"./frontend_application/free_trial/banner_img.png": 379,
	"./frontend_application/free_trial/calendar": 380,
	"./frontend_application/free_trial/calendar.png": 380,
	"./frontend_application/free_trial/calendar_icon": 381,
	"./frontend_application/free_trial/calendar_icon.png": 381,
	"./frontend_application/free_trial/client": 382,
	"./frontend_application/free_trial/client.png": 382,
	"./frontend_application/free_trial/client_five": 383,
	"./frontend_application/free_trial/client_five.png": 383,
	"./frontend_application/free_trial/client_four": 384,
	"./frontend_application/free_trial/client_four.png": 384,
	"./frontend_application/free_trial/client_one": 385,
	"./frontend_application/free_trial/client_one.png": 385,
	"./frontend_application/free_trial/client_three": 386,
	"./frontend_application/free_trial/client_three.png": 386,
	"./frontend_application/free_trial/client_two": 387,
	"./frontend_application/free_trial/client_two.png": 387,
	"./frontend_application/free_trial/crm": 388,
	"./frontend_application/free_trial/crm.png": 388,
	"./frontend_application/free_trial/crm_icon": 389,
	"./frontend_application/free_trial/crm_icon.png": 389,
	"./frontend_application/free_trial/email": 390,
	"./frontend_application/free_trial/email.png": 390,
	"./frontend_application/free_trial/feature_background": 391,
	"./frontend_application/free_trial/feature_background.png": 391,
	"./frontend_application/free_trial/feature_five": 392,
	"./frontend_application/free_trial/feature_five.png": 392,
	"./frontend_application/free_trial/feature_four": 393,
	"./frontend_application/free_trial/feature_four.png": 393,
	"./frontend_application/free_trial/feature_one": 394,
	"./frontend_application/free_trial/feature_one.png": 394,
	"./frontend_application/free_trial/feature_three": 395,
	"./frontend_application/free_trial/feature_three.png": 395,
	"./frontend_application/free_trial/feature_two": 396,
	"./frontend_application/free_trial/feature_two.png": 396,
	"./frontend_application/free_trial/header_background": 397,
	"./frontend_application/free_trial/header_background.png": 397,
	"./frontend_application/free_trial/heading_banner_blue": 398,
	"./frontend_application/free_trial/heading_banner_blue.png": 398,
	"./frontend_application/free_trial/heading_banner_purple": 399,
	"./frontend_application/free_trial/heading_banner_purple.png": 399,
	"./frontend_application/free_trial/icon-calendar-lg": 400,
	"./frontend_application/free_trial/icon-calendar-lg.png": 400,
	"./frontend_application/free_trial/icon-crm-lg": 401,
	"./frontend_application/free_trial/icon-crm-lg.png": 401,
	"./frontend_application/free_trial/icon-marketing-lg": 402,
	"./frontend_application/free_trial/icon-marketing-lg.png": 402,
	"./frontend_application/free_trial/icon-payment-lg": 403,
	"./frontend_application/free_trial/icon-payment-lg.png": 403,
	"./frontend_application/free_trial/icon-stats-lg": 404,
	"./frontend_application/free_trial/icon-stats-lg.png": 404,
	"./frontend_application/free_trial/icon-venue-lg": 405,
	"./frontend_application/free_trial/icon-venue-lg.png": 405,
	"./frontend_application/free_trial/integrated_icon": 406,
	"./frontend_application/free_trial/integrated_icon.png": 406,
	"./frontend_application/free_trial/payment": 407,
	"./frontend_application/free_trial/payment.png": 407,
	"./frontend_application/free_trial/payment_icon": 408,
	"./frontend_application/free_trial/payment_icon.png": 408,
	"./frontend_application/free_trial/psg_one": 409,
	"./frontend_application/free_trial/psg_one.png": 409,
	"./frontend_application/free_trial/psg_two": 410,
	"./frontend_application/free_trial/psg_two.png": 410,
	"./frontend_application/free_trial/quote_img": 411,
	"./frontend_application/free_trial/quote_img.png": 411,
	"./frontend_application/free_trial/report": 412,
	"./frontend_application/free_trial/report.png": 412,
	"./frontend_application/free_trial/report_icon": 413,
	"./frontend_application/free_trial/report_icon.png": 413,
	"./frontend_application/free_trial/room_icon": 414,
	"./frontend_application/free_trial/room_icon.png": 414,
	"./frontend_application/free_trial/service_one": 415,
	"./frontend_application/free_trial/service_one.png": 415,
	"./frontend_application/free_trial/service_three": 416,
	"./frontend_application/free_trial/service_three.png": 416,
	"./frontend_application/free_trial/service_two": 417,
	"./frontend_application/free_trial/service_two.png": 417,
	"./frontend_application/free_trial/venue": 418,
	"./frontend_application/free_trial/venue.png": 418,
	"./frontend_application/free_trial/venuerific_logo": 419,
	"./frontend_application/free_trial/venuerific_logo.png": 419,
	"./frontend_application/good_bye": 420,
	"./frontend_application/good_bye.png": 420,
	"./frontend_application/help/bg-help": 421,
	"./frontend_application/help/bg-help.png": 421,
	"./frontend_application/homepage_reward_desktop": 422,
	"./frontend_application/homepage_reward_desktop.png": 422,
	"./frontend_application/homepage_reward_mobile": 423,
	"./frontend_application/homepage_reward_mobile.png": 423,
	"./frontend_application/img-banner": 424,
	"./frontend_application/img-banner.png": 424,
	"./frontend_application/img-icon": 425,
	"./frontend_application/img-icon.png": 425,
	"./frontend_application/landing-faq": 50,
	"./frontend_application/landing-faq.png": 50,
	"./frontend_application/landing-faq.webp": 884,
	"./frontend_application/laptop": 51,
	"./frontend_application/laptop.png": 51,
	"./frontend_application/laptop.webp": 885,
	"./frontend_application/logo-footer": 426,
	"./frontend_application/logo-footer.png": 426,
	"./frontend_application/logs-blank": 427,
	"./frontend_application/logs-blank.png": 427,
	"./frontend_application/map/hongkong": 428,
	"./frontend_application/map/hongkong.webp": 428,
	"./frontend_application/map/indonesia": 429,
	"./frontend_application/map/indonesia.webp": 429,
	"./frontend_application/map/malaysia": 430,
	"./frontend_application/map/malaysia.webp": 430,
	"./frontend_application/map/philippines": 431,
	"./frontend_application/map/philippines.webp": 431,
	"./frontend_application/map/singapore": 432,
	"./frontend_application/map/singapore.webp": 432,
	"./frontend_application/master_card": 52,
	"./frontend_application/master_card.png": 52,
	"./frontend_application/master_card.svg": 886,
	"./frontend_application/multi-data-icon": 433,
	"./frontend_application/multi-data-icon.png": 433,
	"./frontend_application/myfavourite-blank": 434,
	"./frontend_application/myfavourite-blank.png": 434,
	"./frontend_application/myhosting/call": 435,
	"./frontend_application/myhosting/call.png": 435,
	"./frontend_application/myhosting/completed": 436,
	"./frontend_application/myhosting/completed.png": 436,
	"./frontend_application/myhosting/email": 437,
	"./frontend_application/myhosting/email.png": 437,
	"./frontend_application/myhosting/paid": 438,
	"./frontend_application/myhosting/paid.png": 438,
	"./frontend_application/myhosting/pending": 439,
	"./frontend_application/myhosting/pending.png": 439,
	"./frontend_application/myhosting/quote_required": 440,
	"./frontend_application/myhosting/quote_required.png": 440,
	"./frontend_application/myhosting/rejected": 441,
	"./frontend_application/myhosting/rejected.png": 441,
	"./frontend_application/myhosting/reviewed": 442,
	"./frontend_application/myhosting/reviewed.png": 442,
	"./frontend_application/myhosting/scheduled": 443,
	"./frontend_application/myhosting/scheduled.png": 443,
	"./frontend_application/myhosting/site_visit": 444,
	"./frontend_application/myhosting/site_visit.png": 444,
	"./frontend_application/myhosting/unpaid": 445,
	"./frontend_application/myhosting/unpaid.png": 445,
	"./frontend_application/myhosting/urgent_request": 446,
	"./frontend_application/myhosting/urgent_request.png": 446,
	"./frontend_application/myhosting/whatsapp": 447,
	"./frontend_application/myhosting/whatsapp.png": 447,
	"./frontend_application/myinvitation-blank": 448,
	"./frontend_application/myinvitation-blank.png": 448,
	"./frontend_application/nav-logo": 449,
	"./frontend_application/nav-logo-christmas": 450,
	"./frontend_application/nav-logo-christmas.png": 450,
	"./frontend_application/nav-logo-white": 451,
	"./frontend_application/nav-logo-white-christmas": 452,
	"./frontend_application/nav-logo-white-christmas.png": 452,
	"./frontend_application/nav-logo-white.png": 451,
	"./frontend_application/nav-logo.png": 449,
	"./frontend_application/navicon/black-fav-icon": 453,
	"./frontend_application/navicon/black-fav-icon.svg": 453,
	"./frontend_application/navicon/black-notif-icon": 454,
	"./frontend_application/navicon/black-notif-icon.svg": 454,
	"./frontend_application/navicon/white-fav-icon": 455,
	"./frontend_application/navicon/white-fav-icon.svg": 455,
	"./frontend_application/navicon/white-notif-icon": 456,
	"./frontend_application/navicon/white-notif-icon.svg": 456,
	"./frontend_application/news-placeholder": 457,
	"./frontend_application/news-placeholder.svg": 457,
	"./frontend_application/no-photo-venue": 458,
	"./frontend_application/no-photo-venue.jpg": 458,
	"./frontend_application/nogroup": 459,
	"./frontend_application/nogroup.png": 459,
	"./frontend_application/noinquiries": 460,
	"./frontend_application/noinquiries.png": 460,
	"./frontend_application/noroom": 461,
	"./frontend_application/noroom.png": 461,
	"./frontend_application/notification/event_planner/enquiry_accepted": 462,
	"./frontend_application/notification/event_planner/enquiry_accepted.png": 462,
	"./frontend_application/notification/event_planner/enquiry_declined": 463,
	"./frontend_application/notification/event_planner/enquiry_declined.png": 463,
	"./frontend_application/notification/event_planner/enquiry_read": 464,
	"./frontend_application/notification/event_planner/enquiry_read.png": 464,
	"./frontend_application/notification/event_planner/enquiry_sent": 465,
	"./frontend_application/notification/event_planner/enquiry_sent.png": 465,
	"./frontend_application/notification/event_planner/event_finished": 466,
	"./frontend_application/notification/event_planner/event_finished.png": 466,
	"./frontend_application/notification/event_planner/invoice_sent": 467,
	"./frontend_application/notification/event_planner/invoice_sent.png": 467,
	"./frontend_application/notification/event_planner/news_created": 468,
	"./frontend_application/notification/event_planner/news_created.png": 468,
	"./frontend_application/notification/event_planner/profile_incomplete": 469,
	"./frontend_application/notification/event_planner/profile_incomplete.png": 469,
	"./frontend_application/notification/venue_owner/call_missed": 470,
	"./frontend_application/notification/venue_owner/call_missed.png": 470,
	"./frontend_application/notification/venue_owner/enquiry_accepted": 471,
	"./frontend_application/notification/venue_owner/enquiry_accepted.png": 471,
	"./frontend_application/notification/venue_owner/enquiry_sent": 472,
	"./frontend_application/notification/venue_owner/enquiry_sent.png": 472,
	"./frontend_application/notification/venue_owner/enquiry_unread": 473,
	"./frontend_application/notification/venue_owner/enquiry_unread.png": 473,
	"./frontend_application/notification/venue_owner/event_finished": 474,
	"./frontend_application/notification/venue_owner/event_finished.png": 474,
	"./frontend_application/notification/venue_owner/goal_empty": 475,
	"./frontend_application/notification/venue_owner/goal_empty.png": 475,
	"./frontend_application/notification/venue_owner/goal_unmet": 476,
	"./frontend_application/notification/venue_owner/goal_unmet.png": 476,
	"./frontend_application/notification/venue_owner/payment_submitted": 477,
	"./frontend_application/notification/venue_owner/payment_submitted.png": 477,
	"./frontend_application/notification/venue_owner/profile_missing_phone_number": 478,
	"./frontend_application/notification/venue_owner/profile_missing_phone_number.png": 478,
	"./frontend_application/notification/venue_owner/profile_missing_picture": 479,
	"./frontend_application/notification/venue_owner/profile_missing_picture.png": 479,
	"./frontend_application/notification/venue_owner/promotion_empty": 480,
	"./frontend_application/notification/venue_owner/promotion_empty.png": 480,
	"./frontend_application/notification/venue_owner/review_received": 481,
	"./frontend_application/notification/venue_owner/review_received.png": 481,
	"./frontend_application/notification/venue_owner/stats_summarized": 482,
	"./frontend_application/notification/venue_owner/stats_summarized.png": 482,
	"./frontend_application/nouser_placeholder": 483,
	"./frontend_application/nouser_placeholder.svg": 483,
	"./frontend_application/package-icon": 484,
	"./frontend_application/package-icon.svg": 484,
	"./frontend_application/paper-icon": 485,
	"./frontend_application/paper-icon.svg": 485,
	"./frontend_application/payment-icon": 486,
	"./frontend_application/payment-icon.png": 486,
	"./frontend_application/profile_completed_icon": 487,
	"./frontend_application/profile_completed_icon.svg": 487,
	"./frontend_application/promo-badge": 488,
	"./frontend_application/promo-badge.png": 488,
	"./frontend_application/promo-banner-md": 489,
	"./frontend_application/promo-banner-md.png": 489,
	"./frontend_application/promo-banner-sm": 490,
	"./frontend_application/promo-banner-sm.png": 490,
	"./frontend_application/promo-blank": 491,
	"./frontend_application/promo-blank.png": 491,
	"./frontend_application/promo-icon": 492,
	"./frontend_application/promo-icon.png": 492,
	"./frontend_application/question": 493,
	"./frontend_application/question.png": 493,
	"./frontend_application/review-blank": 494,
	"./frontend_application/review-blank.png": 494,
	"./frontend_application/reward-icon": 495,
	"./frontend_application/reward-icon-lg": 496,
	"./frontend_application/reward-icon-lg.png": 496,
	"./frontend_application/reward-icon.png": 495,
	"./frontend_application/reward_bg": 497,
	"./frontend_application/reward_bg.png": 497,
	"./frontend_application/reward_img": 498,
	"./frontend_application/reward_img.jpg": 498,
	"./frontend_application/sad": 499,
	"./frontend_application/sad.png": 499,
	"./frontend_application/single-data-icon": 500,
	"./frontend_application/single-data-icon.png": 500,
	"./frontend_application/snap": 501,
	"./frontend_application/snap.png": 501,
	"./frontend_application/solution/venuerificpay": 502,
	"./frontend_application/solution/venuerificpay.jpg": 502,
	"./frontend_application/solution/videoprod": 503,
	"./frontend_application/solution/videoprod.jpg": 503,
	"./frontend_application/solution/virtualwedding": 504,
	"./frontend_application/solution/virtualwedding.jpg": 504,
	"./frontend_application/star": 505,
	"./frontend_application/star.png": 505,
	"./frontend_application/stats/icon-bounced": 506,
	"./frontend_application/stats/icon-bounced.png": 506,
	"./frontend_application/stats/icon-clicked": 507,
	"./frontend_application/stats/icon-clicked.png": 507,
	"./frontend_application/stats/icon-clock": 508,
	"./frontend_application/stats/icon-clock.png": 508,
	"./frontend_application/stats/icon-opened": 509,
	"./frontend_application/stats/icon-opened.png": 509,
	"./frontend_application/stats/icon-park_ranking": 510,
	"./frontend_application/stats/icon-park_ranking.png": 510,
	"./frontend_application/stats/icon-send-check": 511,
	"./frontend_application/stats/icon-send-check.png": 511,
	"./frontend_application/stats/icon-unsubscribed": 512,
	"./frontend_application/stats/icon-unsubscribed.png": 512,
	"./frontend_application/stripe-gray-img": 513,
	"./frontend_application/stripe-gray-img.svg": 513,
	"./frontend_application/stripe-img": 514,
	"./frontend_application/stripe-img.png": 514,
	"./frontend_application/subpupgrade": 515,
	"./frontend_application/subpupgrade.png": 515,
	"./frontend_application/three-sixty-icon-sm": 516,
	"./frontend_application/three-sixty-icon-sm.png": 516,
	"./frontend_application/thumb": 517,
	"./frontend_application/thumb.png": 517,
	"./frontend_application/todo-empty": 518,
	"./frontend_application/todo-empty.png": 518,
	"./frontend_application/up-icon": 519,
	"./frontend_application/up-icon.svg": 519,
	"./frontend_application/upload-icon": 520,
	"./frontend_application/upload-icon.jpg": 520,
	"./frontend_application/upload-placeholder": 521,
	"./frontend_application/upload-placeholder.svg": 521,
	"./frontend_application/usernav": 522,
	"./frontend_application/usernav.png": 522,
	"./frontend_application/vca-award-badge": 523,
	"./frontend_application/vca-award-badge.gif": 523,
	"./frontend_application/venue/account-grey": 524,
	"./frontend_application/venue/account-grey.png": 524,
	"./frontend_application/venue/account-img": 525,
	"./frontend_application/venue/account-img.png": 525,
	"./frontend_application/venue/air-conditioning-icon": 526,
	"./frontend_application/venue/air-conditioning-icon.png": 526,
	"./frontend_application/venue/amp-icon": 527,
	"./frontend_application/venue/amp-icon.png": 527,
	"./frontend_application/venue/availability-icon": 528,
	"./frontend_application/venue/availability-icon.png": 528,
	"./frontend_application/venue/bar-icon": 529,
	"./frontend_application/venue/bar-icon.png": 529,
	"./frontend_application/venue/bar-tab-icon": 530,
	"./frontend_application/venue/bar-tab-icon.png": 530,
	"./frontend_application/venue/board-games-icon": 531,
	"./frontend_application/venue/board-games-icon.png": 531,
	"./frontend_application/venue/books-icon": 532,
	"./frontend_application/venue/books-icon.png": 532,
	"./frontend_application/venue/bring-your-own-stuff-icon": 533,
	"./frontend_application/venue/bring-your-own-stuff-icon.png": 533,
	"./frontend_application/venue/bus-stop-icon": 534,
	"./frontend_application/venue/bus-stop-icon.png": 534,
	"./frontend_application/venue/car-park-icon": 535,
	"./frontend_application/venue/car-park-icon.png": 535,
	"./frontend_application/venue/card-games-icon": 536,
	"./frontend_application/venue/card-games-icon.png": 536,
	"./frontend_application/venue/catering-icon": 537,
	"./frontend_application/venue/catering-icon.png": 537,
	"./frontend_application/venue/chairs-icon": 538,
	"./frontend_application/venue/chairs-icon.png": 538,
	"./frontend_application/venue/cleaner-icon": 539,
	"./frontend_application/venue/cleaner-icon.png": 539,
	"./frontend_application/venue/coffee-icon": 540,
	"./frontend_application/venue/coffee-icon.png": 540,
	"./frontend_application/venue/custom-accesibility-icon": 541,
	"./frontend_application/venue/custom-accesibility-icon.png": 541,
	"./frontend_application/venue/darts-icon": 542,
	"./frontend_application/venue/darts-icon.png": 542,
	"./frontend_application/venue/discount-icon": 543,
	"./frontend_application/venue/discount-icon.png": 543,
	"./frontend_application/venue/dj-console-icon": 544,
	"./frontend_application/venue/dj-console-icon.png": 544,
	"./frontend_application/venue/email-icon": 545,
	"./frontend_application/venue/email-icon.png": 545,
	"./frontend_application/venue/enquiry-white-icon": 546,
	"./frontend_application/venue/enquiry-white-icon.png": 546,
	"./frontend_application/venue/event-staff-icon": 547,
	"./frontend_application/venue/event-staff-icon.png": 547,
	"./frontend_application/venue/exclamation-icon": 548,
	"./frontend_application/venue/exclamation-icon.png": 548,
	"./frontend_application/venue/fb-icon": 549,
	"./frontend_application/venue/fb-icon.png": 549,
	"./frontend_application/venue/food-icon": 550,
	"./frontend_application/venue/food-icon.png": 550,
	"./frontend_application/venue/full-bar-icon": 551,
	"./frontend_application/venue/full-bar-icon.png": 551,
	"./frontend_application/venue/games-icon": 552,
	"./frontend_application/venue/games-icon.png": 552,
	"./frontend_application/venue/karaoke-machine-icon": 553,
	"./frontend_application/venue/karaoke-machine-icon.png": 553,
	"./frontend_application/venue/linkedin-icon": 554,
	"./frontend_application/venue/linkedin-icon.png": 554,
	"./frontend_application/venue/microphone-icon": 555,
	"./frontend_application/venue/microphone-icon.png": 555,
	"./frontend_application/venue/nearby-mrt-icon": 556,
	"./frontend_application/venue/nearby-mrt-icon.png": 556,
	"./frontend_application/venue/offer-icon": 557,
	"./frontend_application/venue/offer-icon.png": 557,
	"./frontend_application/venue/other-amenities-icon": 558,
	"./frontend_application/venue/other-amenities-icon.png": 558,
	"./frontend_application/venue/package-deals-icon": 559,
	"./frontend_application/venue/package-deals-icon.png": 559,
	"./frontend_application/venue/package-icon": 560,
	"./frontend_application/venue/package-icon.png": 560,
	"./frontend_application/venue/papers-icon": 561,
	"./frontend_application/venue/papers-icon.png": 561,
	"./frontend_application/venue/pens-icon": 562,
	"./frontend_application/venue/pens-icon.png": 562,
	"./frontend_application/venue/ping-pong-table-icon": 563,
	"./frontend_application/venue/ping-pong-table-icon.png": 563,
	"./frontend_application/venue/pool-table-icon": 564,
	"./frontend_application/venue/pool-table-icon.png": 564,
	"./frontend_application/venue/private-room-icon": 565,
	"./frontend_application/venue/private-room-icon.png": 565,
	"./frontend_application/venue/projector-icon": 566,
	"./frontend_application/venue/projector-icon.png": 566,
	"./frontend_application/venue/restaurant-icon": 567,
	"./frontend_application/venue/restaurant-icon.png": 567,
	"./frontend_application/venue/room-icon": 568,
	"./frontend_application/venue/room-icon.png": 568,
	"./frontend_application/venue/rules-icon": 569,
	"./frontend_application/venue/rules-icon.png": 569,
	"./frontend_application/venue/seats-icon": 570,
	"./frontend_application/venue/seats-icon.png": 570,
	"./frontend_application/venue/size-icon": 571,
	"./frontend_application/venue/size-icon.png": 571,
	"./frontend_application/venue/smoking-area-icon": 572,
	"./frontend_application/venue/smoking-area-icon.png": 572,
	"./frontend_application/venue/sound-system-icon": 573,
	"./frontend_application/venue/sound-system-icon.png": 573,
	"./frontend_application/venue/stage-icon": 574,
	"./frontend_application/venue/stage-icon.png": 574,
	"./frontend_application/venue/standing-icon": 575,
	"./frontend_application/venue/standing-icon.png": 575,
	"./frontend_application/venue/street-parking-icon": 576,
	"./frontend_application/venue/street-parking-icon.png": 576,
	"./frontend_application/venue/swimming-pool-icon": 577,
	"./frontend_application/venue/swimming-pool-icon.png": 577,
	"./frontend_application/venue/tables-icon": 578,
	"./frontend_application/venue/tables-icon.png": 578,
	"./frontend_application/venue/taxi-stand-icon": 579,
	"./frontend_application/venue/taxi-stand-icon.png": 579,
	"./frontend_application/venue/tea-icon": 580,
	"./frontend_application/venue/tea-icon.png": 580,
	"./frontend_application/venue/tech-support-icon": 581,
	"./frontend_application/venue/tech-support-icon.png": 581,
	"./frontend_application/venue/tv-screen-icon": 582,
	"./frontend_application/venue/tv-screen-icon.png": 582,
	"./frontend_application/venue/twitter-icon": 583,
	"./frontend_application/venue/twitter-icon.png": 583,
	"./frontend_application/venue/valet-service-icon": 584,
	"./frontend_application/venue/valet-service-icon.png": 584,
	"./frontend_application/venue/venue-img-five": 585,
	"./frontend_application/venue/venue-img-five.jpg": 585,
	"./frontend_application/venue/venue-img-four": 586,
	"./frontend_application/venue/venue-img-four.jpg": 586,
	"./frontend_application/venue/venue-img-one": 587,
	"./frontend_application/venue/venue-img-one.jpg": 587,
	"./frontend_application/venue/venue-img-three": 588,
	"./frontend_application/venue/venue-img-three.jpg": 588,
	"./frontend_application/venue/venue-img-two": 589,
	"./frontend_application/venue/venue-img-two.jpg": 589,
	"./frontend_application/venue/whatsapp-icon": 590,
	"./frontend_application/venue/whatsapp-icon.png": 590,
	"./frontend_application/venue/whatsapp-lg-icon": 591,
	"./frontend_application/venue/whatsapp-lg-icon.png": 591,
	"./frontend_application/venue/whatsapp-white-icon": 592,
	"./frontend_application/venue/whatsapp-white-icon.png": 592,
	"./frontend_application/venue/white-board-icon": 593,
	"./frontend_application/venue/white-board-icon.png": 593,
	"./frontend_application/venue/wifi-icon": 594,
	"./frontend_application/venue/wifi-icon.png": 594,
	"./frontend_application/video-icon": 595,
	"./frontend_application/video-icon-sm": 596,
	"./frontend_application/video-icon-sm.png": 596,
	"./frontend_application/video-icon.png": 595,
	"./frontend_application/visa": 53,
	"./frontend_application/visa.png": 53,
	"./frontend_application/visa.svg": 887,
	"./frontend_application/vnfc-bank-logo": 597,
	"./frontend_application/vnfc-bank-logo.svg": 597,
	"./frontend_application/vnfc-new-pay-logo": 598,
	"./frontend_application/vnfc-new-pay-logo.svg": 598,
	"./frontend_application/vnfc-pay-logo": 599,
	"./frontend_application/vnfc-pay-logo.png": 599,
	"./google-icon": 600,
	"./google-icon.png": 600,
	"./hk": 601,
	"./hk.png": 601,
	"./home/banner_flashdeal": 602,
	"./home/banner_flashdeal.png": 602,
	"./home/btn_next": 603,
	"./home/btn_next.png": 603,
	"./home/btn_prev": 604,
	"./home/btn_prev.png": 604,
	"./home/img_baby-shower": 605,
	"./home/img_baby-shower.png": 605,
	"./home/img_badge": 606,
	"./home/img_badge.png": 606,
	"./home/img_birthday-party": 607,
	"./home/img_birthday-party.png": 607,
	"./home/img_company-dinner-and-dance": 608,
	"./home/img_company-dinner-and-dance.png": 608,
	"./home/img_corporate-seminar": 609,
	"./home/img_corporate-seminar.png": 609,
	"./home/img_meeting": 610,
	"./home/img_meeting.png": 610,
	"./home/img_thumb-1": 611,
	"./home/img_thumb-1.png": 611,
	"./home/img_thumb-2": 612,
	"./home/img_thumb-2.png": 612,
	"./home/img_thumb-3": 613,
	"./home/img_thumb-3.png": 613,
	"./home/img_wedding": 614,
	"./home/img_wedding.png": 614,
	"./icon1": 615,
	"./icon1.svg": 615,
	"./icon2": 616,
	"./icon2.svg": 616,
	"./icon3": 617,
	"./icon3.svg": 617,
	"./icons/chevron-left-circle": 618,
	"./icons/chevron-left-circle.png": 618,
	"./icons/favourite": 619,
	"./icons/favourite.png": 619,
	"./icons/my_venues": 620,
	"./icons/my_venues.png": 620,
	"./icons/venue_group": 621,
	"./icons/venue_group.png": 621,
	"./id": 622,
	"./id.png": 622,
	"./img-icon": 623,
	"./img-icon.png": 623,
	"./jewel": 624,
	"./jewel.png": 624,
	"./linkedin-icon": 625,
	"./linkedin-icon.png": 625,
	"./logo": 626,
	"./logo-christmas": 627,
	"./logo-christmas.png": 627,
	"./logo.png": 626,
	"./millennium": 628,
	"./millennium.png": 628,
	"./mox": 629,
	"./mox.png": 629,
	"./my": 630,
	"./my.png": 630,
	"./new-assets/emoji/party": 631,
	"./new-assets/emoji/party.png": 631,
	"./new-assets/promo-badge": 632,
	"./new-assets/promo-badge.png": 632,
	"./new-assets/user": 633,
	"./new-assets/user.png": 633,
	"./pasarbella": 634,
	"./pasarbella.png": 634,
	"./payments/calendar-icon": 635,
	"./payments/calendar-icon.svg": 635,
	"./payments/card-gray-icon": 636,
	"./payments/card-gray-icon.png": 636,
	"./payments/card-icon": 637,
	"./payments/card-icon.svg": 637,
	"./payments/credit-card": 638,
	"./payments/credit-card.jpg": 638,
	"./payments/dashboard": 639,
	"./payments/dashboard.png": 639,
	"./payments/header": 640,
	"./payments/header-mobile": 641,
	"./payments/header-mobile.jpg": 641,
	"./payments/header.jpg": 640,
	"./payments/logo": 642,
	"./payments/logo.svg": 642,
	"./payments/monitor-icon": 643,
	"./payments/monitor-icon.svg": 643,
	"./payments/payment-illustration-1": 644,
	"./payments/payment-illustration-1.svg": 644,
	"./payments/payment-illustration-2": 645,
	"./payments/payment-illustration-2.svg": 645,
	"./payments/payment-illustration-3": 646,
	"./payments/payment-illustration-3.svg": 646,
	"./payments/payment-wrapper": 647,
	"./payments/payment-wrapper.svg": 647,
	"./payments/seamless": 648,
	"./payments/seamless.jpg": 648,
	"./payments/sites": 649,
	"./payments/sites.svg": 649,
	"./payments/web-icon": 650,
	"./payments/web-icon.svg": 650,
	"./ph": 651,
	"./ph.png": 651,
	"./private-venue/1": 652,
	"./private-venue/1.png": 652,
	"./private-venue/2": 653,
	"./private-venue/2.png": 653,
	"./private-venue/banner-main": 654,
	"./private-venue/banner-main.png": 654,
	"./private-venue/bg-benefit": 655,
	"./private-venue/bg-benefit.png": 655,
	"./private-venue/bg-cta": 656,
	"./private-venue/bg-cta.png": 656,
	"./private-venue/bg-hover-cheers": 657,
	"./private-venue/bg-hover-cheers.png": 657,
	"./private-venue/bg-hover-home": 658,
	"./private-venue/bg-hover-home.png": 658,
	"./private-venue/bg-hover-unique": 659,
	"./private-venue/bg-hover-unique.png": 659,
	"./private-venue/bg-hover-work": 660,
	"./private-venue/bg-hover-work.png": 660,
	"./private-venue/bg-stats": 661,
	"./private-venue/bg-stats.png": 661,
	"./private-venue/bridge": 662,
	"./private-venue/bridge.png": 662,
	"./private-venue/calendar": 663,
	"./private-venue/calendar.svg": 663,
	"./private-venue/chart": 664,
	"./private-venue/chart.svg": 664,
	"./private-venue/cheers": 665,
	"./private-venue/cheers.svg": 665,
	"./private-venue/csc": 666,
	"./private-venue/csc.png": 666,
	"./private-venue/distrii": 667,
	"./private-venue/distrii.png": 667,
	"./private-venue/experience": 668,
	"./private-venue/experience.svg": 668,
	"./private-venue/hover-cheers": 669,
	"./private-venue/hover-cheers.svg": 669,
	"./private-venue/hover-private": 670,
	"./private-venue/hover-private.svg": 670,
	"./private-venue/hover-unique": 671,
	"./private-venue/hover-unique.svg": 671,
	"./private-venue/hover-work": 672,
	"./private-venue/hover-work.svg": 672,
	"./private-venue/location": 673,
	"./private-venue/location.png": 673,
	"./private-venue/partnership": 674,
	"./private-venue/partnership.png": 674,
	"./private-venue/pin": 675,
	"./private-venue/pin.svg": 675,
	"./private-venue/private": 676,
	"./private-venue/private.svg": 676,
	"./private-venue/professional": 677,
	"./private-venue/professional.svg": 677,
	"./private-venue/trust": 678,
	"./private-venue/trust.svg": 678,
	"./private-venue/unique": 679,
	"./private-venue/unique.svg": 679,
	"./private-venue/wework": 680,
	"./private-venue/wework.png": 680,
	"./private-venue/work": 681,
	"./private-venue/work.svg": 681,
	"./responsive-icon": 682,
	"./responsive-icon.png": 682,
	"./room-icon": 683,
	"./room-icon.png": 683,
	"./search/bg_search_activities": 684,
	"./search/bg_search_activities.png": 684,
	"./search/yellow_buildings": 685,
	"./search/yellow_buildings.png": 685,
	"./sg": 686,
	"./sg.png": 686,
	"./skills-future-logo": 687,
	"./skills-future-logo.png": 687,
	"./slider1": 688,
	"./slider1.jpg": 688,
	"./super-venue/badge-card-supervenue": 689,
	"./super-venue/badge-card-supervenue.svg": 689,
	"./super-venue/badge-venue-supervenue": 690,
	"./super-venue/badge-venue-supervenue.svg": 690,
	"./super-venue/benefits1": 691,
	"./super-venue/benefits1.png": 691,
	"./super-venue/benefits2": 692,
	"./super-venue/benefits2.png": 692,
	"./super-venue/icons/badge": 693,
	"./super-venue/icons/badge.svg": 693,
	"./super-venue/icons/filter": 694,
	"./super-venue/icons/filter.svg": 694,
	"./super-venue/icons/search": 695,
	"./super-venue/icons/search.svg": 695,
	"./super-venue/icons/support": 696,
	"./super-venue/icons/support.svg": 696,
	"./super-venue/myaccount": 697,
	"./super-venue/myaccount.png": 697,
	"./super-venue/supervenue": 698,
	"./super-venue/supervenue.png": 698,
	"./testimg": 699,
	"./testimg.png": 699,
	"./testimonial/aaron_lee_all_to_gather": 700,
	"./testimonial/aaron_lee_all_to_gather.jpg": 700,
	"./testimonial/aliff": 701,
	"./testimonial/aliff.jpeg": 701,
	"./testimonial/chen": 702,
	"./testimonial/chen.jpeg": 702,
	"./testimonial/daniellim_csc": 703,
	"./testimonial/daniellim_csc.png": 703,
	"./testimonial/jonathanpang_distrii": 704,
	"./testimonial/jonathanpang_distrii.png": 704,
	"./testimonial/kanthan_jay_sk_hall": 705,
	"./testimonial/kanthan_jay_sk_hall.jpeg": 705,
	"./testimonial/ophelia": 706,
	"./testimonial/ophelia.jpeg": 706,
	"./testimonial/raymond_howe": 707,
	"./testimonial/raymond_howe.jpeg": 707,
	"./testimonial/ying": 708,
	"./testimonial/ying.png": 708,
	"./trophy-icon": 709,
	"./trophy-icon.png": 709,
	"./up-icon": 710,
	"./up-icon-blue": 711,
	"./up-icon-blue.svg": 711,
	"./up-icon.svg": 710,
	"./user_blank": 712,
	"./user_blank.png": 712,
	"./vca/banner-main": 713,
	"./vca/banner-main-2022": 714,
	"./vca/banner-main-2022.png": 714,
	"./vca/banner-main.png": 713,
	"./vca/bg-about": 715,
	"./vca/bg-about-2022": 716,
	"./vca/bg-about-2022.png": 716,
	"./vca/bg-about.png": 715,
	"./vca/bg-cat": 717,
	"./vca/bg-cat.png": 717,
	"./vca/bg-category": 718,
	"./vca/bg-category.png": 718,
	"./vca/bg-category2022": 719,
	"./vca/bg-category2022.png": 719,
	"./vca/bg-howto": 720,
	"./vca/bg-howto-2022": 721,
	"./vca/bg-howto-2022.png": 721,
	"./vca/bg-howto.png": 720,
	"./vca/bg-popup": 722,
	"./vca/bg-popup-2022": 723,
	"./vca/bg-popup-2022.png": 723,
	"./vca/bg-popup-2023": 724,
	"./vca/bg-popup-2023.png": 724,
	"./vca/bg-popup.png": 722,
	"./vca/bg-sponsor": 725,
	"./vca/bg-sponsor-2022": 726,
	"./vca/bg-sponsor-2022.png": 726,
	"./vca/bg-sponsor.old": 727,
	"./vca/bg-sponsor.old.png": 727,
	"./vca/bg-sponsor.png": 725,
	"./vca/categories/cafe": 728,
	"./vca/categories/cafe.png": 728,
	"./vca/categories/innovative": 729,
	"./vca/categories/innovative.png": 729,
	"./vca/categories/intimate": 730,
	"./vca/categories/intimate.png": 730,
	"./vca/categories/popular": 731,
	"./vca/categories/popular.png": 731,
	"./vca/categories/resilient": 732,
	"./vca/categories/resilient.png": 732,
	"./vca/categories/restaurant": 733,
	"./vca/categories/restaurant.png": 733,
	"./vca/categories/risingstar": 734,
	"./vca/categories/risingstar.png": 734,
	"./vca/categories/yacht": 735,
	"./vca/categories/yacht.png": 735,
	"./vca/congrats": 736,
	"./vca/congrats.png": 736,
	"./vca/facebook": 737,
	"./vca/facebook.png": 737,
	"./vca/nome0": 738,
	"./vca/nome0.png": 738,
	"./vca/nome1": 739,
	"./vca/nome1.png": 739,
	"./vca/nome2": 740,
	"./vca/nome2.png": 740,
	"./vca/nome3": 741,
	"./vca/nome3.png": 741,
	"./vca/nome4": 742,
	"./vca/nome4.png": 742,
	"./vca/nome5": 743,
	"./vca/nome5.png": 743,
	"./vca/nomf0": 744,
	"./vca/nomf0.png": 744,
	"./vca/nomf1": 745,
	"./vca/nomf1.png": 745,
	"./vca/nomf2": 746,
	"./vca/nomf2.png": 746,
	"./vca/nomf3": 747,
	"./vca/nomf3.png": 747,
	"./vca/nomf4": 748,
	"./vca/nomf4.png": 748,
	"./vca/nomf5": 749,
	"./vca/nomf5.png": 749,
	"./vca/nomg0": 750,
	"./vca/nomg0.png": 750,
	"./vca/nomg1": 751,
	"./vca/nomg1.png": 751,
	"./vca/nomg2": 752,
	"./vca/nomg2.png": 752,
	"./vca/nomg3": 753,
	"./vca/nomg3.png": 753,
	"./vca/nomg4": 754,
	"./vca/nomg4.png": 754,
	"./vca/nomg5": 755,
	"./vca/nomg5.png": 755,
	"./vca/nomh0": 756,
	"./vca/nomh0.png": 756,
	"./vca/nomh1": 757,
	"./vca/nomh1.png": 757,
	"./vca/nomh2": 758,
	"./vca/nomh2.png": 758,
	"./vca/nomh3": 759,
	"./vca/nomh3.png": 759,
	"./vca/nomh4": 760,
	"./vca/nomh4.png": 760,
	"./vca/nomh5": 761,
	"./vca/nomh5.png": 761,
	"./vca/prizes/anjalichocolat": 762,
	"./vca/prizes/anjalichocolat.png": 762,
	"./vca/prizes/beautehub": 763,
	"./vca/prizes/beautehub.png": 763,
	"./vca/prizes/conspicuousscents": 764,
	"./vca/prizes/conspicuousscents.png": 764,
	"./vca/prizes/feast": 765,
	"./vca/prizes/feast.png": 765,
	"./vca/prizes/human": 766,
	"./vca/prizes/human.png": 766,
	"./vca/prizes/ifly": 767,
	"./vca/prizes/ifly.png": 767,
	"./vca/prizes/motionartspace": 768,
	"./vca/prizes/motionartspace.png": 768,
	"./vca/prizes/onthelist": 769,
	"./vca/prizes/onthelist.png": 769,
	"./vca/prizes/tbakery": 770,
	"./vca/prizes/tbakery.png": 770,
	"./vca/prizes/vrworld": 771,
	"./vca/prizes/vrworld.png": 771,
	"./vca/sponsors/anjalichocolat": 772,
	"./vca/sponsors/anjalichocolat.png": 772,
	"./vca/sponsors/beautehub": 773,
	"./vca/sponsors/beautehub.png": 773,
	"./vca/sponsors/beautenails": 774,
	"./vca/sponsors/beautenails.png": 774,
	"./vca/sponsors/bhmedicalaeshtetics": 775,
	"./vca/sponsors/bhmedicalaeshtetics.png": 775,
	"./vca/sponsors/conspicuousscents": 776,
	"./vca/sponsors/conspicuousscents.png": 776,
	"./vca/sponsors/feast": 777,
	"./vca/sponsors/feast.png": 777,
	"./vca/sponsors/human": 778,
	"./vca/sponsors/human.png": 778,
	"./vca/sponsors/ifly": 779,
	"./vca/sponsors/ifly.png": 779,
	"./vca/sponsors/motionartspace": 780,
	"./vca/sponsors/motionartspace.png": 780,
	"./vca/sponsors/onthelist": 781,
	"./vca/sponsors/onthelist.png": 781,
	"./vca/sponsors/tbakery": 782,
	"./vca/sponsors/tbakery.png": 782,
	"./vca/sponsors/vrworld": 783,
	"./vca/sponsors/vrworld.png": 783,
	"./vca/step1": 784,
	"./vca/step1.png": 784,
	"./vca/step2": 785,
	"./vca/step2.png": 785,
	"./vca/step3": 786,
	"./vca/step3.png": 786,
	"./vca/step4": 787,
	"./vca/step4.png": 787,
	"./vca/trophy": 788,
	"./vca/trophy.png": 788,
	"./vca/vca": 789,
	"./vca/vca-2022": 790,
	"./vca/vca-2022.png": 790,
	"./vca/vca.png": 789,
	"./vca/venuewinner": 791,
	"./vca/venuewinner.png": 791,
	"./vca/whatsapp": 792,
	"./vca/whatsapp.png": 792,
	"./vca/winner1": 793,
	"./vca/winner1.png": 793,
	"./vca/winner2": 794,
	"./vca/winner2.png": 794,
	"./vca/winner3": 795,
	"./vca/winner3.png": 795,
	"./vca/winner4": 796,
	"./vca/winner4.png": 796,
	"./venue-icon": 797,
	"./venue-icon.png": 797,
	"./venue_sample": 798,
	"./venue_sample.png": 798,
	"./video-icon": 799,
	"./video-icon.png": 799,
	"./wedding_success/broadcast": 800,
	"./wedding_success/broadcast.png": 800,
	"./wedding_success/crew": 801,
	"./wedding_success/crew.png": 801,
	"./wedding_success/devices": 802,
	"./wedding_success/devices.png": 802,
	"./wedding_success/room": 803,
	"./wedding_success/room.png": 803,
	"./wedding_success/tvw_logo": 804,
	"./wedding_success/tvw_logo.png": 804,
	"./why-vendor/01": 805,
	"./why-vendor/01.png": 805,
	"./why-vendor/02": 806,
	"./why-vendor/02.png": 806,
	"./why-vendor/03": 807,
	"./why-vendor/03.png": 807,
	"./why-vendor/banner-main": 808,
	"./why-vendor/banner-main.png": 808,
	"./why-vendor/notfound": 809,
	"./why-vendor/notfound.png": 809,
	"./why-vendor/user": 810,
	"./why-vendor/user.svg": 810,
	"./why-vendor/venue": 811,
	"./why-vendor/venue.svg": 811,
	"./why/banner-demo": 812,
	"./why/banner-demo.jpg": 812,
	"./why/banner-main": 813,
	"./why/banner-main.jpg": 813,
	"./why/bg-testi": 814,
	"./why/bg-testi.png": 814,
	"./why/calendar": 815,
	"./why/calendar.png": 815,
	"./why/client1": 816,
	"./why/client1.png": 816,
	"./why/client2": 817,
	"./why/client2.png": 817,
	"./why/crm": 818,
	"./why/crm.png": 818,
	"./why/curated": 819,
	"./why/curated.png": 819,
	"./why/endtoend": 820,
	"./why/endtoend.png": 820,
	"./why/manage": 821,
	"./why/manage.png": 821,
	"./why/payment": 822,
	"./why/payment.png": 822,
	"./why/reporting": 823,
	"./why/reporting.png": 823,
	"./why/room": 824,
	"./why/room.png": 824,
	"./why/setmeeting": 825,
	"./why/setmeeting.png": 825,
	"./why/smartvenue": 826,
	"./why/smartvenue.png": 826,
	"./why/venue": 827,
	"./why/venue.png": 827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 877;